module.exports = __webpack_public_path__ + "img/Member icon-05.09a22d72.png";